import EndpointsUrls from "@/onedesk-portal.userendpoints.json";
export const state = {
    root: true,
    version: "2.0",
    graphQLApiUrl: EndpointsUrls.graphQLApiUrl,
};
